
import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/components/ui/use-toast';

export const useArticleProgressService = () => {
  // Track article read progress
  const updateArticleReadProgress = useCallback(async (articleId: string, percentage: number) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        console.log('User not authenticated, skipping read progress update');
        return;
      }
      
      // Check if record exists first
      const { data: existingReads, error: readCheckError } = await supabase
        .from('article_reads')
        .select('*')
        .eq('user_id', user.id)
        .eq('article_id', articleId);
      
      if (readCheckError) {
        console.error('Error checking read progress:', readCheckError);
        return;
      }
      
      if (existingReads && existingReads.length > 0) {
        // Update existing record if new percentage is higher
        const existingRead = existingReads[0];
        if (percentage > existingRead.read_percentage) {
          const { error: updateError } = await supabase
            .from('article_reads')
            .update({
              read_percentage: percentage,
              is_complete: percentage >= 90,
              updated_at: new Date().toISOString()
            })
            .eq('id', existingRead.id);
            
          if (updateError) {
            console.error('Error updating read progress:', updateError);
          }
        }
      } else {
        // Create new record
        const { error: insertError } = await supabase
          .from('article_reads')
          .insert({
            user_id: user.id,
            article_id: articleId,
            read_percentage: percentage,
            is_complete: percentage >= 90
          });
          
        if (insertError) {
          console.error('Error creating read progress:', insertError);
        }
      }
    } catch (err) {
      console.error('Error in updateArticleReadProgress:', err);
    }
  }, []);

  return { updateArticleReadProgress };
};
